<script lang="ts">
export default {
    name: "leftHeader",
};
</script>

<script setup lang="ts">
import { onMounted } from "vue";
import { store } from '@/store'
import { getCityList, getAreaList, getOrgList, getProductInfo } from "@/api/system/index"

const cityCode = ref()

const cityOptions: any = ref([])

const CityList = () => {
    getCityList().then((res) => {
        cityOptions.value = res.list
    })
}

const areaCode = ref()

const countyOptions: any = ref([])

const AreaList = () => {
    areaCode.value = ""
    provinceCode.value = ""
    const foundObject = cityOptions.value.find((item: any) => item.cityCode == cityCode.value);
    store.informationListStore.informationStore().setCityObj(foundObject)
    store.informationListStore.informationStore().setOrganizationData({
        cityCode: cityCode.value,
        areaCode: areaCode.value,
        provinceCode: provinceCode.value
    })
    getAreaList(cityCode.value).then((res) => {
        countyOptions.value = res.areaList
    })
}

const provinceCode = ref()

const squadronOptions = ref()

const OrgList = () => {
    provinceCode.value = ""
    const params: any = {}
    params.cityCode = cityCode.value
    params.areaCode = areaCode.value
    const foundObject = countyOptions.value.find((item: any) => item.areaCode == areaCode.value);
    store.informationListStore.informationStore().setAreaObj(foundObject)
    store.informationListStore.informationStore().setOrganizationData({
        cityCode: cityCode.value,
        areaCode: areaCode.value,
        provinceCode: provinceCode.value
    })
    getOrgList(params).then((res) => {
        squadronOptions.value = res.list
    })
}
const provinceChange = () => {
    const foundObject = squadronOptions.value.find((item: any) => item.id == provinceCode.value);
    store.informationListStore.informationStore().setorgObj(foundObject)
    store.informationListStore.informationStore().setOrganizationData({
        cityCode: cityCode.value,
        areaCode: areaCode.value,
        provinceCode: provinceCode.value
    })
}

const urlKey = ref()
const title = ref()
onMounted(() => {
    CityList()
    if (localStorage.getItem("cityCode")) {
        cityCode.value = localStorage.getItem("cityCode")
    }
    if (localStorage.getItem("areaCode")) {
        AreaList()
        areaCode.value = localStorage.getItem("areaCode")
    }
    if (localStorage.getItem("provinceCode")) {
        OrgList()
        provinceCode.value = localStorage.getItem("provinceCode")
    }
    if (sessionStorage.getItem("key")) {
        urlKey.value = sessionStorage.getItem("key")
        getProductInfo(urlKey.value).then((res) => {
            title.value = res.productName
        })
    }
})
</script>

<template>
    <div class="left-header">
        <div class="selectBox">
            <el-select v-model="cityCode" placeholder="市级" size="large" style="width: 7.5rem;" @change="AreaList()"
                popper-class="select-option" clearable>
               
                <el-option v-for="item in cityOptions" :key="item.cityCode" :label="item.cityName"
                    :value="item.cityCode" />
            </el-select>
            <el-select v-model="areaCode" placeholder="县级" size="large" style="width: 7.5rem" @change="OrgList()"
                popper-class="select-option" clearable>
                <el-option v-for="item in countyOptions" :key="item.areaCode" :label="item.areaName"
                    :value="item.areaCode" />
            </el-select>
            <el-select v-model="provinceCode" placeholder="中队" size="large" style="width: 12rem"
                @change="provinceChange" popper-class="select-option" clearable>
                <el-option v-for="item in squadronOptions" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
        </div>
    </div>
</template>

<style lang="scss">
.select-option {
    background: rgba(11, 12, 41, 0.8) !important;
    border: 1px solid rgba(45, 227, 255, 0.4) !important;
    .el-select-dropdown__item {
        color: #fff;
    }

    .el-select-dropdown__item.selected {
        font-size: 14px;
        font-weight: 400;
        background: linear-gradient(270deg, rgba(52, 143, 254, 0) 0%, #348FFE 100%) !important;
    }

    .el-select-dropdown__item.is-hovering {
        background: linear-gradient(270deg, rgba(52, 143, 254, 0) 0%, #348FFE 100%) !important;
    }

    .el-popper__arrow:before {
        background: linear-gradient(270deg, rgba(52, 143, 254, 0) 0%, #348FFE 100%) !important;
    }
}
</style>

<style scoped lang="scss">
.left-header {
    height: 10.2vh;
    .headerBox {
        width: 27.6vw;
        height: 3.3vh;
        color: #FFFFFF;
        text-align: center;
        text-shadow: 2px 3px 3px rgba(0, 0, 0, .5);

        img {
            width: 25.375rem;
            height: 2.125rem;
        }
    }

    .selectBox {
        width: 20.2vw;
        margin-left: 2rem;
        text-align: right;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 1.375rem;
        pointer-events: all;
        :deep(.el-select) {
            height: 3.2vh;
            border: none;

            .el-select__wrapper {
                min-height: 3.2vh;
                background-color: transparent;
                border: none;
                box-shadow: none;
                font-size: 1.125rem;
                color: #fff;
                background: linear-gradient(180deg, #FFFFFF 0%, #97D6FF 64%, #5EC0FF 86%, #8DD2FF 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text;
                backdrop-filter: blur(5.44px);
                text-shadow: 0px 0px 20px rgba(0, 133, 255, 0.7151);
                font-family: AlibabaPuHuiTi;
                .el-select__caret{
                    content: url('@/assets/icons/xiala.png'); /* 你的自定义图标路径 */
                    width: 15px; /* 根据图标大小调整 */
                    height: 10px; /* 根据图标大小调整 */
                    // background-color: #5EC0FF;
                }
            }

            .el-select__placeholder {
                color: #fff;
                font-size: 1.125rem !important;
                background: linear-gradient(180deg, #FFFFFF 0%, #97D6FF 64%, #5EC0FF 86%, #8DD2FF 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                background-clip: text;
                backdrop-filter: blur(5.44px);
                text-shadow: 0px 0px 20px rgba(0, 133, 255, 0.7151);
                font-family: AlibabaPuHuiTi;
            }
        }
    }
}
</style>
